import { useEffect, useRef, useState } from 'react';

import type { Icon } from '../svgs/types';

export const CustomIcon = ({ iconFileName }: { iconFileName: string }) => {
  const ref = useRef<Icon | null>(null);
  const [isFetching, setFetching] = useState<boolean>(true);

  useEffect(() => {
    setFetching(true);
  }, [iconFileName]);

  useEffect(() => {
    const getSvg = async () => {
      try {
        const icon = await import(`../svgs/${iconFileName}.svg`);

        ref.current = icon.default;
      } catch (error) {
        ref.current = null;
      } finally {
        setFetching(false);
      }
    };

    if (isFetching) void getSvg();
  }, [iconFileName, isFetching]);

  if (ref.current) {
    const SVG = ref.current;

    return <SVG />;
  }

  return null;
};
